import { Component } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'ba-server-error',
  templateUrl: './server-error.component.html'
})
export class ServerErrorComponent {

  constructor(
    public router: Router
  ) { }

  /**
   * If user clicks on Take me home button he will be redirected to location items if he is logged in,
   * else it will redirect to login page
   */
  redirectToMainPage() {
    if (localStorage.getItem('loggedInUser')) {
      this.router.navigate(['/sales/locationItems']);
    } else {
      this.router.navigate(['login']);
    }
  }

}
